<template>
  <div class="body-div">
    <span class="filter-buttons">
      <div class="report-wrapper">
        <date-picker
          lang="en"
          placeholder="Select Date"
          :not-after="new Date()"
          v-model="reportDate"
          input-class="form-control"
        ></date-picker>
        <button
          :disabled="reportDate === null"
          :class="{ disabled: reportDate === null }"
          class="bttn"
          @click="getReportByDate"
        >
          Get Report
        </button>
      </div>
      <div class="filter-group">
        <div>
          <input
            @click="changeDataFilter($event)"
            type="radio"
            name="filters"
            id="all"
            value="ALL"
            checked
          />
          <label for="all">ALL</label>
        </div>
        <div>
          <input
            @click="changeDataFilter($event)"
            type="radio"
            name="filters"
            id="reg"
            value="REG"
          />
          <label for="reg">REG</label>
        </div>
        <div>
          <input
            @click="changeDataFilter($event)"
            type="radio"
            name="filters"
            id="dup"
            value="DUP"
          />
          <label for="dup">DUP</label>
        </div>
      </div>
    </span>
    <div class="main-nav styleCard">
      <ul class="style-nav style1">
        <li
          v-for="tab in timeTabs"
          :key="tab.id"
          class="router-link"
          @click="selectedTimeTab = tab.alias"
          :class="{ active: selectedTimeTab === tab.alias }"
        >
          {{ tab.name }}
        </li>
      </ul>
    </div>
    <div class="top-div" v-if="selectedTimeTab === 'TODAY'">
      <div class="table">
        <table
          v-if="
            !Array.isArray(notInterested[0]) &&
              notInterested[0].total_in_time_frame > 0
          "
        >
          <thead>
            <tr class="text-center">
              {{
                GetTimeText("0")
              }}
              |
              {{
                notInterested[0].total_in_time_frame
              }}
            </tr>
          </thead>
          <tbody>
            <table>
              <tr>
                <td
                  v-for="cond in notInterested[0].campaign_aaid.slice(0, 3)"
                  :key="cond.id"
                >
                  <span
                    >{{ cond.id }} | {{ cond.amount }} |
                    {{ notInterested[0].total_in_time_frame }} |
                    {{
                      (
                        (100 * cond.amount) /
                        notInterested[0].total_in_time_frame
                      ).toFixed(2)
                    }}%</span
                  >
                </td>
              </tr>
              <tr>
                <td
                  v-for="cond in notInterested[0].users.slice(0, 3)"
                  :key="cond.id"
                >
                  <span>
                    {{
                      salesPersonList.find(item => item.id === cond.id)
                        .full_name
                    }}
                    | {{ cond.amount }} |
                    {{ notInterested[0].total_in_time_frame }} |
                    {{
                      (
                        (100 * cond.amount) /
                        notInterested[0].total_in_time_frame
                      ).toFixed(2)
                    }}%
                  </span>
                </td>
              </tr>
              <tr>
                <td
                  v-for="cond in notInterested[0].country_id.slice(0, 3)"
                  :key="cond.id"
                >
                  <span
                    >{{
                      dictionaries.general.countries.find(
                        country => country.id === cond.id
                      ).name
                    }}
                    | {{ cond.amount }} |
                    {{ notInterested[0].total_in_time_frame }} |
                    {{
                      (
                        (100 * cond.amount) /
                        notInterested[0].total_in_time_frame
                      ).toFixed(2)
                    }}%</span
                  >
                </td>
              </tr>
              <tr>
                <td
                  v-for="cond in notInterested[0].keyword.slice(0, 3)"
                  :key="cond.id"
                >
                  <span
                    >{{ cond.id }} | {{ cond.amount }} |
                    {{ notInterested[0].total_in_time_frame }} |
                    {{
                      (
                        (100 * cond.amount) /
                        notInterested[0].total_in_time_frame
                      ).toFixed(2)
                    }}%</span
                  >
                </td>
              </tr>
              <hr />
            </table>
          </tbody>
        </table>
      </div>

      <loader
        class="loader"
        :size="'8px'"
        v-if="
          notInterestedBusy[0] ||
            notInterestedBusy[1] ||
            notInterestedBusy[30] ||
            notInterestedBusy[90]
        "
      ></loader>
    </div>
    <div class="top-div" v-if="selectedTimeTab === 'YESTERDAY'">
      <div class="table">
        <table
          v-if="
            !Array.isArray(notInterested[1]) &&
              notInterested[1].total_in_time_frame > 0
          "
        >
          <thead>
            <tr class="text-center">
              {{
                GetTimeText("1")
              }}
              |
              {{
                notInterested[1].total_in_time_frame
              }}
            </tr>
          </thead>
          <tbody>
            <table>
              <tr>
                <td
                  v-for="cond in notInterested[1].campaign_aaid.slice(0, 3)"
                  :key="cond.id"
                >
                  <span
                    >{{ cond.id }} | {{ cond.amount }} |
                    {{ notInterested[1].total_in_time_frame }} |
                    {{
                      (
                        (100 * cond.amount) /
                        notInterested[1].total_in_time_frame
                      ).toFixed(2)
                    }}%</span
                  >
                  <br />
                  <span
                    class="report-rank"
                    v-for="rank in cond.rankings"
                    :key="rank"
                    v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                  >
                    <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">
                      {{ rank["id"] }}:{{ rank["rank"] }}|
                    </span>
                  </span>
                </td>
              </tr>
              <tr>
                <td
                  v-for="cond in notInterested[1].users.slice(0, 3)"
                  :key="cond.id"
                >
                  <span>
                    {{
                      salesPersonList.find(item => item.id === cond.id)
                        .full_name
                    }}
                    | {{ cond.amount }} |
                    {{ notInterested[1].total_in_time_frame }} |
                    {{
                      (
                        (100 * cond.amount) /
                        notInterested[1].total_in_time_frame
                      ).toFixed(2)
                    }}%
                  </span>
                  <br />
                  <span
                    class="report-rank"
                    v-for="rank in cond.rankings"
                    :key="rank"
                    v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                  >
                    <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">
                      {{ rank["id"] }}:{{ rank["rank"] }}|
                    </span>
                  </span>
                </td>
              </tr>
              <tr>
                <td
                  v-for="cond in notInterested[1].country_id.slice(0, 3)"
                  :key="cond.id"
                >
                  <span
                    >{{
                      dictionaries.general.countries.find(
                        country => country.id === cond.id
                      ).name
                    }}
                    | {{ cond.amount }} |
                    {{ notInterested[1].total_in_time_frame }} |
                    {{
                      (
                        (100 * cond.amount) /
                        notInterested[1].total_in_time_frame
                      ).toFixed(2)
                    }}%</span
                  >
                  <br />
                  <span
                    class="report-rank"
                    v-for="rank in cond.rankings"
                    :key="rank"
                    v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                  >
                    <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">
                      {{ rank["id"] }}:{{ rank["rank"] }}|
                    </span>
                  </span>
                </td>
              </tr>
              <tr>
                <td
                  v-for="cond in notInterested[1].keyword.slice(0, 3)"
                  :key="cond.id"
                >
                  <span
                    >{{ cond.id }} | {{ cond.amount }} |
                    {{ notInterested[1].total_in_time_frame }} |
                    {{
                      (
                        (100 * cond.amount) /
                        notInterested[1].total_in_time_frame
                      ).toFixed(2)
                    }}%</span
                  >
                  <br />
                  <span
                    class="report-rank"
                    v-for="rank in cond.rankings"
                    :key="rank"
                    v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                  >
                    <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">
                      {{ rank["id"] }}:{{ rank["rank"] }}|
                    </span>
                  </span>
                </td>
              </tr>
              <hr />
            </table>
          </tbody>
        </table>
      </div>

      <loader
        class="loader"
        :size="'8px'"
        v-if="
          notInterestedBusy[0] ||
            notInterestedBusy[1] ||
            notInterestedBusy[30] ||
            notInterestedBusy[90]
        "
      ></loader>
    </div>
    <div class="top-div" v-if="selectedTimeTab === '30DAYS'">
      <div class="table">
        <table
          v-if="
            !Array.isArray(notInterested[30]) &&
              notInterested[30].total_in_time_frame > 0
          "
        >
          <thead>
            <tr class="text-center">
              {{
                GetTimeText("30")
              }}
              |
              {{
                notInterested[30].total_in_time_frame
              }}
            </tr>
          </thead>
          <tbody>
            <table>
              <tr>
                <td
                  v-for="cond in notInterested[30].campaign_aaid.slice(0, 3)"
                  :key="cond.id"
                >
                  <span
                    >{{ cond.id }} | {{ cond.amount }} |
                    {{ notInterested[30].total_in_time_frame }} |
                    {{
                      (
                        (100 * cond.amount) /
                        notInterested[30].total_in_time_frame
                      ).toFixed(2)
                    }}%</span
                  >
                  <br />
                  <span
                    class="report-rank"
                    v-for="rank in cond.rankings"
                    :key="rank"
                    v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                  >
                    <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">
                      {{ rank["id"] }}:{{ rank["rank"] }}|
                    </span>
                  </span>
                </td>
              </tr>
              <tr>
                <td
                  v-for="cond in notInterested[30].users.slice(0, 3)"
                  :key="cond.id"
                >
                  <span>
                    {{
                      salesPersonList.find(item => item.id === cond.id)
                        .full_name
                    }}
                    | {{ cond.amount }} |
                    {{ notInterested[30].total_in_time_frame }} |
                    {{
                      (
                        (100 * cond.amount) /
                        notInterested[30].total_in_time_frame
                      ).toFixed(2)
                    }}%
                  </span>
                  <br />
                  <span
                    class="report-rank"
                    v-for="rank in cond.rankings"
                    :key="rank"
                    v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                  >
                    <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">
                      {{ rank["id"] }}:{{ rank["rank"] }}|
                    </span>
                  </span>
                </td>
              </tr>
              <tr>
                <td
                  v-for="cond in notInterested[30].country_id.slice(0, 3)"
                  :key="cond.id"
                >
                  <span
                    >{{
                      dictionaries.general.countries.find(
                        country => country.id === cond.id
                      ).name
                    }}
                    | {{ cond.amount }} |
                    {{ notInterested[30].total_in_time_frame }} |
                    {{
                      (
                        (100 * cond.amount) /
                        notInterested[30].total_in_time_frame
                      ).toFixed(2)
                    }}%</span
                  >
                  <br />
                  <span
                    class="report-rank"
                    v-for="rank in cond.rankings"
                    :key="rank"
                    v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                  >
                    <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">
                      {{ rank["id"] }}:{{ rank["rank"] }}|
                    </span>
                  </span>
                </td>
              </tr>
              <tr>
                <td
                  v-for="cond in notInterested[30].keyword.slice(0, 3)"
                  :key="cond.id"
                >
                  <span
                    >{{ cond.id }} | {{ cond.amount }} |
                    {{ notInterested[30].total_in_time_frame }} |
                    {{
                      (
                        (100 * cond.amount) /
                        notInterested[30].total_in_time_frame
                      ).toFixed(2)
                    }}%</span
                  >
                  <br />
                  <span
                    class="report-rank"
                    v-for="rank in cond.rankings"
                    :key="rank"
                    v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                  >
                    <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">
                      {{ rank["id"] }}:{{ rank["rank"] }}|
                    </span>
                  </span>
                </td>
              </tr>
              <hr />
            </table>
          </tbody>
        </table>
      </div>

      <loader
        class="loader"
        :size="'8px'"
        v-if="
          notInterestedBusy[0] ||
            notInterestedBusy[1] ||
            notInterestedBusy[30] ||
            notInterestedBusy[90]
        "
      ></loader>
    </div>
    <div class="top-div" v-if="selectedTimeTab === '90DAYS'">
      <div class="table">
        <table
          v-if="
            !Array.isArray(notInterested[90]) &&
              notInterested[90].total_in_time_frame > 0
          "
        >
          <thead>
            <tr class="text-center">
              {{
                GetTimeText("90")
              }}
              |
              {{
                notInterested[90].total_in_time_frame
              }}
            </tr>
          </thead>
          <tbody>
            <table>
              <tr>
                <td
                  v-for="cond in notInterested[90].campaign_aaid.slice(0, 3)"
                  :key="cond.id"
                >
                  <span
                    >{{ cond.id }} | {{ cond.amount }} |
                    {{ notInterested[90].total_in_time_frame }} |
                    {{
                      (
                        (100 * cond.amount) /
                        notInterested[90].total_in_time_frame
                      ).toFixed(2)
                    }}%</span
                  >
                  <br />
                  <span
                    class="report-rank"
                    v-for="rank in cond.rankings"
                    :key="rank"
                    v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                  >
                    <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">
                      {{ rank["id"] }}:{{ rank["rank"] }}|
                    </span>
                  </span>
                </td>
              </tr>
              <tr>
                <td
                  v-for="cond in notInterested[90].users.slice(0, 3)"
                  :key="cond.id"
                >
                  <span>
                    {{
                      salesPersonList.find(item => item.id === cond.id)
                        .full_name
                    }}
                    | {{ cond.amount }} |
                    {{ notInterested[90].total_in_time_frame }} |
                    {{
                      (
                        (100 * cond.amount) /
                        notInterested[90].total_in_time_frame
                      ).toFixed(2)
                    }}%
                  </span>
                  <br />
                  <span
                    class="report-rank"
                    v-for="rank in cond.rankings"
                    :key="rank"
                    v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                  >
                    <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">
                      {{ rank["id"] }}:{{ rank["rank"] }}|
                    </span>
                  </span>
                </td>
              </tr>
              <tr>
                <td
                  v-for="cond in notInterested[90].country_id.slice(0, 3)"
                  :key="cond.id"
                >
                  <span
                    >{{
                      dictionaries.general.countries.find(
                        country => country.id === cond.id
                      ).name
                    }}
                    | {{ cond.amount }} |
                    {{ notInterested[90].total_in_time_frame }} |
                    {{
                      (
                        (100 * cond.amount) /
                        notInterested[90].total_in_time_frame
                      ).toFixed(2)
                    }}%</span
                  >
                  <br />
                  <span
                    class="report-rank"
                    v-for="rank in cond.rankings"
                    :key="rank"
                    v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                  >
                    <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">
                      {{ rank["id"] }}:{{ rank["rank"] }}|
                    </span>
                  </span>
                </td>
              </tr>
              <tr>
                <td
                  v-for="cond in notInterested[90].keyword.slice(0, 3)"
                  :key="cond.id"
                >
                  <span
                    >{{ cond.id }} | {{ cond.amount }} |
                    {{ notInterested[90].total_in_time_frame }} |
                    {{
                      (
                        (100 * cond.amount) /
                        notInterested[90].total_in_time_frame
                      ).toFixed(2)
                    }}%</span
                  >
                  <br />
                  <span
                    class="report-rank"
                    v-for="rank in cond.rankings"
                    :key="rank"
                    v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                  >
                    <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">
                      {{ rank["id"] }}:{{ rank["rank"] }}|
                    </span>
                  </span>
                </td>
              </tr>
              <hr />
            </table>
          </tbody>
        </table>
      </div>

      <loader
        class="loader"
        :size="'8px'"
        v-if="
          notInterestedBusy[0] ||
            notInterestedBusy[1] ||
            notInterestedBusy[30] ||
            notInterestedBusy[90]
        "
      ></loader>
    </div>
    <div class="bottom-div" v-if="false">
      <span v-if="false"
        >Forbidden, You are not authorized to see this data</span
      >
      <div class="fab"><span class="fas fa-file-csv"></span></div>
    </div>
  </div>
</template>

<script>
import Loader from "../../../../../main/misc.main/loader/Loader";
import {mapGetters, mapState} from "vuex";
import apiClientCreator from "../../../../../helpers/api/request";
import DatePicker from "vue2-datepicker";
import moment from "moment";
export default {
  name: "NotInterestedLead.container",
  components: { Loader, DatePicker },
  data() {
    return {
      notInterestedBusy: {
        0: false,
        1: false,
        30: false,
        90: false
      },
      notInterested: {
        0: [],
        1: [],
        30: [],
        90: []
      },
      rawData: {
        0: [],
        1: [],
        30: [],
        90: []
      },
      filterOption: "ALL",
      reportDate: null,
      timeTabs: [
        {
          id: 0,
          name: "Today",
          alias: "TODAY"
        },
        {
          id: 1,
          name: "Yesterday",
          alias: "YESTERDAY"
        },
        {
          id: 2,
          name: "Last 30 Days",
          alias: "30DAYS"
        },
        {
          id: 3,
          name: "Last 90 Days",
          alias: "90DAYS"
        }
      ],
      selectedTimeTab: "TODAY"
    };
  },
  computed: {
    ...mapState("user", ["auth"]),
    ...mapGetters("user", ["isLogged"]),
    ...mapState("clients", [
      "dictionaries",
      "salesPersonList",
      "selectedStatisticsTimeFrameTab"
    ])
  },
  created() {
    this.getNotInterestedByTimeFrame(0);
    this.getNotInterestedByTimeFrame(1);
    this.getNotInterestedByTimeFrame(30);
    this.getNotInterestedByTimeFrame(90);

    this.selectedTimeTab = this.selectedStatisticsTimeFrameTab;
  },
  watch: {
    selectedTimeTab: function() {
      this.$store.commit(
        "clients/setSelectedStatisticsTimeFrameTab",
        this.selectedTimeTab
      );
    }

    // selectedStatisticsTimeFrameTab: function () {
    //   this.selectedTimeTab = this.selectedStatisticsTimeFrameTab
    // }
  },
  methods: {
    async getNotInterestedByTimeFrame(timeFrame) {
      if (
        !this.notInterestedBusy[timeFrame] &&
        this.checkPermissions(this.auth, [1, 2, 3, 4, 12])
      ) {
        try {
          this.notInterestedBusy[timeFrame] = true;
          const res = await apiClientCreator(
            `reports/not_interested_lead/${timeFrame}/true`
          ).get("");
          this.rawData[timeFrame] = res.data["all_data"];
          this.notInterested[timeFrame] = this.rawData[timeFrame][
            this.filterOption
          ];
          this.notInterestedBusy[timeFrame] = false;
        } catch (e) {}
      }
    },
    checkPermissions(user, permitted) {
      return permitted.some(role => role === user.user.role);
    },
    GetTimeText(time) {
      if (time === "0") return "Today";
      if (time === "1") return "Yesterday";
      else return "Last " + time + " days";
    },
    changeDataFilter(event) {
      let time_frames = [1, 30, 90];
      time_frames.forEach(time => {
        this.notInterested[time] = this.rawData[time][event.target.value];
      });
    },
    async getReportByDate() {
      if (this.checkPermissions(this.auth, [1, 2, 3, 4, 12])) {
        try {
          const res = await apiClientCreator(
            `reports/asset_report_by_date/not_interested_leads/${moment(
              this.reportDate
            ).format("YYYY-MM-DD")}`
          ).get("");
          let time_frames = [1, 30, 90];
          time_frames.forEach(time => {
            this.rawData[time] = res.data[time]["all_data"];
            this.notInterested[time] = this.rawData[time][this.filterOption];
          });
        } catch (e) {}
      }
    }
  }
};
</script>

<style scoped>
.body-div {
  padding: 4px 5px 1px 5px;
}
.top-div {
  height: 650px;
  overflow-y: scroll;
  margin: auto;
  background: white;
  border-radius: 3px;
  padding: 5px;
}
.bottom-div {
  width: 100%;
  height: 650px;
  overflow-y: scroll;
  margin: 5px auto;
  background: white;
  border-radius: 3px;
  padding: 5px;
  position: relative;
}
.fab {
  background-color: transparent;
  padding: 0;
  font-size: 30px;
  line-height: 30px;
  color: green;
  text-align: center;
  position: absolute;
  right: 10px;
  bottom: 10px;
  border-radius: 20%;
  transition: all 0.1s ease-in-out;
  cursor: pointer;
}

.fab:hover {
  box-shadow: 0 5px 11px 0 #666;
  transform: scale(1.05);
}
.table {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 20px;
}
.table td {
  padding: 0.3em 0;
}
.table table {
  font-size: 13px;
  width: 1500px;
  margin: 3em 0;
}
.table thead {
  border-bottom: solid 2px #eff3f6;
}
.table tfoot {
  border-top: solid 2px #eff3f6;
  color: red;
}
.table th {
  text-align: center;
}
.text-center {
  font-weight: bold;
}
.loader {
  left: 0;
  right: 0;
}
.style-nav {
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  position: relative;
}
.style-nav .router-link {
  max-width: 150px;
  min-width: 72px;
  height: 28px;
  margin: 0;
  cursor: pointer;
  background: white;
  border-radius: 0;
  font-size: 11px;
  color: black;
  text-align: center;
  vertical-align: middle;
  line-height: 28px;
  border-bottom: 2px solid transparent;
  flex-grow: 1;
  transition: background 0.3s ease, color 0.3s ease;
}

.style-nav.style2 li:not(.empty):hover {
  transform: translateY(5px);
}

.style-nav.style2 li.active {
  border-bottom: 2px solid #44a2d2 !important;
  color: #44a2d2;
}

.style-nav.style1 .router-link:not(.empty):hover {
  background: #44a2d2;
  color: white;
  text-decoration: none;
}

.style-nav.style1 .router-link.active {
  border-bottom: 2px solid #44a2d2 !important;
  background: #44a2d2;
  color: white;
  text-decoration: none;
}
.negative {
  color: red;
}
.positive {
  color: green;
}
.filter-buttons {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: white;
}
input {
  margin: 0.4em;
}
.filter-group {
  padding-right: 6em;
}
.bttn {
  width: 100%;
  margin-top: 0.5rem;
  background: #44a2d2;
  color: white;
  border: 0;
  border-radius: inherit;
  padding: 5px;
  font-size: 12px;
  font-family: inherit;
  cursor: pointer;
}
.disabled {
  background-color: #cccccc;
  color: #666666;
  cursor: not-allowed;
}
.report-wrapper {
  display: flex;
  flex-direction: column;
}
</style>
